import { Card, PrimaryButton, Title } from "components/atoms";

export default function Welcome({ onNext = () => {} }) {
  const handleClick = (event) => {
    event.preventDefault();
    onNext();
  };

  return (
    <div className="flex justify-between w-full">
      <div
        className="w-full bg-no-repeat bg-right"
        style={{
          backgroundImage: `url("/assets/icons/welcome-left.png")`,
        }}
      />
      <Card className="mt-16 z-10 flex flex-col justify-around">
        {/* TITLE BLOCK */}
        <div className="relative w-fit mx-auto">
          <Title className="text-center z-10 border-dotted uppercase text-black">
            Quiz
          </Title>
          <div className="w-8 border-b border-black mx-auto"></div>
        </div>

        <h2 className="font-tt-ramillas-trl-bold-italic text-center text-[25px] text-third mt-8 mb-5 leading-[33px]">
          Le handicap
        </h2>

        <p className="text-black text-center font-tt-ramillas-trl-regular text-[20px] leading-[27px]">
          Ce quiz vous invite à explorer les bonnes pratiques pour créer un
          environnement accueillant et respectueux, tout en renforçant vos
          connaissances.
          <br />
          En comprenant mieux les enjeux du handicap, vous pourrez faire la
          différence, aussi bien dans votre équipe qu’auprès de vos clients.
          <br />
          <br />
          🤝 En magasin, chaque interaction compte, que ce soit avec vos
          collègues ou vos clients.
          <br />
          Savoir répondre aux besoins des personnes en situation de handicap,
          qu’ils soient visibles ou non, est une étape clé pour offrir un
          service inclusif et attentif.
        </p>
        <br />
        <p className="text-black text-center font-tt-ramillas-trl-regular text-[20px] leading-[24px]">
          Alors, prêt(e) à relever le défi et à devenir un acteur de l’inclusion
          ? 🚀
          <br />
          <br />
          👉 Testez-vous et faites la différence !
        </p>
        <div className="flex justify-center mt-10">
          <PrimaryButton onClick={handleClick}>Commencer</PrimaryButton>
        </div>
      </Card>
      <div
        className="w-full bg-no-repeat mb-20 bg-left-bottom
        "
        style={{
          backgroundImage: `url("/assets/icons/welcome-right.jpg")`,
        }}
      />
    </div>
  );
}
